import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Form,
  Label,
  Input,
} from "reactstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

import { routeNameValidation } from "../../Shared/validation";
import { updateRouteHeader } from "../../services/myRoute.service";

import "react-toastify/dist/ReactToastify.css";
import "../../pages/MyRoutes/myroutes.scss";
import "./editRouteModal.scss";
import edit_icon from "../../assets/edit_pencil.svg";
import calender_icon from "../../assets/calende-icon.svg";

function EditRouteModal({
  showEditRouteModal,
  toggleEditRoute,
  setShowEditRouteModal,
  routeName,
  setRouteName,
  routeDate,
  setRouteDate,
  fetchUserRoutes,
  id,
}) {
  const [errors, setErrors] = useState({});
  const [showClearDate, setShowClearDate] = useState("none");
  const [showClearRouteName, setShowClearRouteName] = useState("none");
  const [values, setValues] = useState({
    routeName: "",
  });

  console.log(showClearDate, showClearRouteName);

  const today = new Date();
  const userEmail = useSelector(
    (state) => state?.userDetailReducer?.userData?.email
  );

  useEffect(() => {
    routeName ? setShowClearRouteName("block") : setShowClearRouteName("none");
    routeDate ? setShowClearDate("block") : setShowClearDate("none");
  }, [routeName, routeDate]);

  const handleRouteName = (e) => {
    const { id, value } = e?.target;
    setValues({
      ...values,
      [id]: value,
    });

    setRouteName(e?.target?.value);
    setErrors({
      [id]: null,
    });
    if (values === "") {
      setShowClearRouteName("none");
    } else {
      setShowClearRouteName("block");
    }
  };

  // const clearBtn = () => {
  //   setRouteName("");
  //   setShowClearRouteName("none");
  // };

  // const clearStartDate = () => {
  //   setRouteDate(null);
  //   setShowClearDate("none");
  // };

  const handleDate = (e) => {
    setRouteDate(e);
    if (e === null) {
      setShowClearDate("none");
    } else {
      setShowClearDate("block");
    }
  };

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  const submitEditRoute = async (e) => {
    e.preventDefault();
    const errorsx = await routeNameValidation(routeName);
    setErrors(errorsx);
    if (!errorsx) {
      try {
        const response = await updateRouteHeader({
          userName: userEmail,
          routeID: id,
          routeName: routeName,
          routeStartingDate: routeDate,
        });
        if (response && response?.status === 200) {
          fetchUserRoutes();
          toast.success("Route Updated Successful!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        } else {
          toast.error("Can Not Update Route!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      } catch (err) {
        let error_message = "Can Not Update Route!";
        if (
          err?.response &&
          err?.response?.data &&
          err?.response?.data?.message
        ) {
          error_message = err?.response?.data?.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
      setValues({
        routeName: "",
      });
      setRouteName("");
      setRouteDate(null);
      setShowClearRouteName("none");
      setShowClearDate("none");
      setShowEditRouteModal(false);
    }
  };

  const datepickerRef = useRef(null);
  const handleDateClick = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setFocus();
      datepickerRef.current?.setOpen(true);
    }
  };

  return (
    <div>
      <Modal
        className="addnew_route modal-dialog-centered"
        isOpen={showEditRouteModal}
        toggle={toggleEditRoute}
      >
        <div className="edit_modal_header" toggle={toggleEditRoute}>
          <img src={edit_icon} alt="" />
          <p> Edit Route</p>
        </div>
        <ModalBody>
          <Form className="edit_route_form">
            <div className="nt-newRouteName">
              <div className="nt-form_lab">
                <Label className="nt-form-city">Route Name:</Label>
                {/* <button
                  className="clear-btn"
                  type="button"
                  onClick={clearBtn}
                  style={{ display: showClearRouteName }}
                >
                  clear
                </button> */}
              </div>
              <div className="nt-route-name">
                <Input
                  type="text"
                  id="routeName"
                  name="routeName"
                  autoComplete="off"
                  value={routeName}
                  onChange={handleRouteName}
                  maxLength="100"
                />
                <span className="error">
                  {errors?.routeName && errors?.routeName}
                </span>
              </div>
            </div>
            <div className="nt-startpoint_nd_date">
              <div className="nt-form_group">
                <div className="nt-form_lab">
                  <Label>Starting Date:</Label>
                  {/* <button
                  className="clear-btn"
                  type="button"
                  onClick={clearStartDate}
                  style={{ display: showClearDate }}
                >
                  clear
                </button> */}
                </div>
                <div className="nt-start-date">
                  <DatePicker
                    selected={routeDate !== null ? new Date(routeDate) : ""}
                    onChange={handleDate}
                    minDate={today}
                    showDisabledMonthNavigation
                    className="custom_date"
                    dateFormat="dd/MM/yyyy"
                    onChangeRaw={handleDateChangeRaw}
                    placeholder="Enter Start Date"
                    ref={datepickerRef}
                  />

                  <img
                    src={calender_icon}
                    alt="calendar icon"
                    onClick={handleDateClick}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            </div>
          </Form>
        </ModalBody>
        <div className="edit_modal_footer">
          <Button className="btn_cancel" onClick={toggleEditRoute}>
            Cancel
          </Button>
          <Button
            className="btn_submit"
            type="submit"
            onClick={submitEditRoute}
          >
            Update Route
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default EditRouteModal;
